import { Directive, HostListener, Input } from '@angular/core'
/**
 * A directive that prevents any input on a component except numerci ones
 */
@Directive({
  selector: '[ngxNumericOnly]',
  standalone: true
})
export class NumericOnlyDirective {
  /**
   * Whether it's enabled or disabled
   */
  @Input() ngxNumericOnly: boolean
  /**
   * Handles keystrokes
   * @param event any
   * @returns void
   */
  @HostListener('keydown', ['$event']) onKeyDown(event) {
    const e = <KeyboardEvent>event
    if (this.ngxNumericOnly) {
      if (
        // tslint:disable-next-line:deprecation
        [46, 8, 9, 27, 13].indexOf(e.keyCode) !== -1 ||
        // Allow: Ctrl+A
        // tslint:disable-next-line:deprecation
        (e.keyCode === 65 && (e.ctrlKey || e.metaKey)) ||
        // Allow: Ctrl+C
        // tslint:disable-next-line:deprecation
        (e.keyCode === 67 && (e.ctrlKey || e.metaKey)) ||
        // Allow: Ctrl+V
        // tslint:disable-next-line:deprecation
        (e.keyCode === 86 && (e.ctrlKey || e.metaKey)) ||
        // Allow: Ctrl+X
        // tslint:disable-next-line:deprecation
        (e.keyCode === 88 && (e.ctrlKey || e.metaKey)) ||
        // Allow: home, end, left, right
        // tslint:disable-next-line:deprecation
        (e.keyCode >= 35 && e.keyCode <= 39)
      ) {
        // let it happen, don't do anything
        return
      }
      // Ensure that it is a number and stop the keypress
      // tslint:disable-next-line:deprecation
      if ((e.shiftKey || e.keyCode < 48 || e.keyCode > 57) && (e.keyCode < 96 || e.keyCode > 105)) {
        e.preventDefault()
      }
    }
  }
}
